export default __webpack_public_path__ + "static/media/placeholder-download.a109bbc5.png";